import { Alert } from "PFComponents/alert";
import { profileHash } from "PFCore/helpers/profile_hash";
import { UiRoute } from "PFCore/utilities/routes";
import footerPng from "PFImages/client/kpmg/KPMG_AU_CV_Footer.png";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { getTranslationKey } from "../../../../../helpers/custom_pptx_template";
import PagePreview from "../../../../../parts/page_preview";
import { PreviewProps } from "../../../../types";
import { pagePreviewStyle } from "../../../constants";
import { getSidebarCustomTypes } from "../helpers";
import { Contacts } from "./components/contacts";
import { CustomField } from "./components/custom_field";
import { Positions } from "./components/positions";
import { Summary } from "./components/summary";
import css from "./kpmg_au_pptx_preview.module.scss";

export const KpmgAuPptxPreview = ({ profile, order, config, avatar, logo }: PreviewProps) => {
  const { templateKey, isBlindModeOn, hidden } = config;
  const {
    _originalData: { internal_experiences: internalExperiences },
    customTypes,
    jobTitle,
    name,
    positions,
    summary
  } = profile;
  const { t } = useTranslation("profiles", { keyPrefix: "export" });

  const translationKey = getTranslationKey(templateKey);

  const sidebarCustomTypes = useMemo(
    () => getSidebarCustomTypes(order, hidden, customTypes),
    [customTypes, hidden, order]
  );

  const showSummary = summary && order.includes("summary") && !hidden.summary;
  const showExperience = positions && order.includes("experience") && !hidden.positions;

  return (
    <>
      {profile.enabled === false && (
        <Alert kind="warning" title="Disabled" style={{ marginBottom: 20, marginTop: 20 }}>
          This profile won&apos;vt be exported when exporting all profiles at once because it&apos;vs disabled
          in the <b>Profiles</b> tab
        </Alert>
      )}
      <PagePreview style={pagePreviewStyle}>
        <div className={css.sidebar}>
          {avatar && !isBlindModeOn && <img className={css.avatar} src={avatar} alt="avatar" />}
          <div className={css.sidebarDetails}>
            <div className={css.profileName}>
              {isBlindModeOn ? `Candidate ${profileHash(profile.id)}` : name}
            </div>
            {jobTitle && <div className={css.jobTitle}>{jobTitle}</div>}
            {!isBlindModeOn && <Contacts profile={profile} />}
            {sidebarCustomTypes.map((customType) => (
              <CustomField key={customType.type.name} customType={customType} />
            ))}
          </div>
          <img className={css.logo} src={logo.url} height={33} alt="" />
        </div>
        <div className={css.main}>
          {showSummary && <Summary summary={summary} title={t(`${translationKey}.summary`)} />}
          {showExperience && (
            <Positions
              positions={positions}
              internalExperiences={internalExperiences}
              title={t(`${translationKey}.positions`)}
            />
          )}
          <img className={css.footer} alt="" src={UiRoute(footerPng)} />
        </div>
      </PagePreview>
    </>
  );
};
